<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Historia Clínica</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ {{ isEditMode ? 'Editar' : 'Primera vez' }}</span>
    </div>
  </div>
  <div class="d-flex my-xl-auto right-content mr-2">
    <button type="button" class="btn btn-secondary me-2" (click)="cancel()">Cerrar</button>
    <button type="button" class="btn btn-outline-primary me-2" [disabled]="loading || !order" (click)="previsualizarPdf()">
      <i class="fa fa-file-pdf-o me-1"></i>
      Previsualizar PDF
    </button>
    <button type="button" class="btn btn-primary" [disabled]="saving || loading" (click)="save()">
      <i class="fa fa-save me-1"></i>
      {{ saving ? 'Guardando...' : (isEditMode ? 'Actualizar' : 'Guardar') }}
    </button>
    <button type="button" class="btn btn-info ms-2" [disabled]="loading || !order" (click)="solicitarServiciosOrden()">
      <i class="fa fa-plus-square me-1"></i>
      Solicitar servicios
    </button>
  </div>
</div>

<div *ngIf="loading" class="text-center clinical-loading">
  <div class="spinner-grow" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  <p class="mt-2">Procesando por favor espere...</p>
</div>

<form [formGroup]="form" *ngIf="!loading" class="clinical-form">
  <div class="card mb-3" *ngIf="order">
    <div class="card-header">
      <h6 class="mb-0">DATOS DE LA ORDEN</h6>
    </div>
    <div class="card-body">
      <div class="row row-sm">
        <div class="col-md-2">
          <label>ORDEN</label>
          <input class="form-control" [value]="order.order_number" readonly>
        </div>
        <div class="col-md-2">
          <label>FACTURA</label>
          <input class="form-control" [value]="order.invoice_number || 'Sin factura'" readonly>
        </div>
        <div class="col-md-3">
          <label>PACIENTE</label>
          <input class="form-control" [value]="order.patient_name || order.NOM_CLI" readonly>
        </div>
        <div class="col-md-3">
          <label>MÉDICO ORDEN</label>
          <input class="form-control" [value]="order.doctor_name || order.NOM_DOC" readonly>
        </div>
        <div class="col-md-2">
          <label>SUCURSAL</label>
          <input class="form-control" [value]="order.branch_name" readonly>
        </div>
      </div>
    </div>
  </div>

  <div class="clinical-required-note">
    <span class="required-dot"></span>
    Las secciones marcadas como obligatorias contienen al menos un campo requerido. Complete los campos con asterisco rojo antes de guardar.
  </div>

  <div class="clinical-progress-panel">
    <div class="clinical-progress-main">
      <div>
        <label>AVANCE DE CAMPOS OBLIGATORIOS</label>
        <strong>{{ requiredCompleted }} de {{ requiredTotal }} secciones completas</strong>
      </div>
      <span>{{ completionPercent }}%</span>
    </div>
    <div class="progress clinical-progress">
      <div class="progress-bar" role="progressbar" [style.width.%]="completionPercent"></div>
    </div>
    <div class="clinical-section-pills">
      <button
        type="button"
        class="section-pill"
        *ngFor="let section of requiredSectionCards"
        [ngClass]="isRequiredSectionComplete(section.key) ? 'section-pill-complete' : 'section-pill-pending'"
        (click)="openSection(section.key)"
        >
        <i class="fa" [ngClass]="isRequiredSectionComplete(section.key) ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
        {{ section.label }}
      </button>
    </div>
  </div>

  <div class="card mb-3" formGroupName="admission">
    <div class="card-header clinical-section-header" (click)="toggleSection('admission')">
      <h6 class="mb-0">A. REGISTRO DE ADMISIÓN Y DATOS DEL PACIENTE</h6>
      <div class="clinical-header-actions">
        <span class="section-badge section-badge-required" *ngIf="isRequiredSection('admission')">Obligatorio</span>
        <span class="section-badge section-badge-warning" *ngIf="hasMissingRequiredInSection('admission')">Faltan datos</span>
        <i class="fa" [ngClass]="isSectionCollapsed('admission') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </div>
    </div>
    <div class="card-body" [ngbCollapse]="isSectionCollapsed('admission')">
      <div class="row row-sm">
        <div class="col-md-4 mb-3">
          <label class="required-field">ESTABLECIMIENTO DE SALUD</label>
          <input class="form-control" [ngClass]="{'is-invalid-soft': form.get('admission.health_facility')?.invalid && form.get('admission.health_facility')?.touched}" formControlName="health_facility" placeholder="Establecimiento de salud">
          <small class="text-danger" *ngIf="form.get('admission.health_facility')?.invalid && form.get('admission.health_facility')?.touched">Requerido</small>
        </div>
        <div class="col-md-4 mb-3">
          <label class="required-field">N° HISTORIA CLÍNICA / CÉDULA</label>
          <div class="input-group">
            <input class="form-control" [ngClass]="{'is-invalid-soft': form.get('admission.clinical_record_number')?.invalid && form.get('admission.clinical_record_number')?.touched}" formControlName="clinical_record_number" placeholder="Identificación">
            <button type="button" class="btn btn-primary" [disabled]="loadingIdentification" (click)="consultarIdentificacion()">
              <i class="fa fa-search"></i>
            </button>
          </div>
          <small class="text-danger" *ngIf="form.get('admission.clinical_record_number')?.invalid && form.get('admission.clinical_record_number')?.touched">Requerido</small>
          <small class="text-muted" *ngIf="loadingIdentification">Consultando identificación...</small>
        </div>
        <div class="col-md-4 mb-3">
          <label class="required-field">APELLIDOS</label>
          <input class="form-control" [ngClass]="{'is-invalid-soft': form.get('admission.last_names')?.invalid && form.get('admission.last_names')?.touched}" formControlName="last_names" placeholder="Apellidos">
          <small class="text-danger" *ngIf="form.get('admission.last_names')?.invalid && form.get('admission.last_names')?.touched">Requerido</small>
        </div>
        <div class="col-md-4 mb-3">
          <label>NOMBRES</label>
          <input class="form-control" formControlName="names" placeholder="Nombres">
        </div>
        <div class="col-md-2 mb-3">
          <label>F. NACIMIENTO</label>
          <input type="date" class="form-control" formControlName="birth_date" (change)="calculateAgeFromAdmission()">
        </div>
        <div class="col-md-2 mb-3">
          <label>EDAD</label>
          <input class="form-control" formControlName="age" placeholder="Edad">
        </div>
        <div class="col-md-2 mb-3">
          <label class="required-field">SEXO</label>
          <select class="form-control" [ngClass]="{'is-invalid-soft': form.get('admission.sex')?.invalid && form.get('admission.sex')?.touched}" formControlName="sex">
            <option value="">Seleccione...</option>
            <option value="Hombre">Hombre</option>
            <option value="Mujer">Mujer</option>
          </select>
          <small class="text-danger" *ngIf="form.get('admission.sex')?.invalid && form.get('admission.sex')?.touched">Requerido</small>
        </div>
        <div class="col-md-2 mb-3">
          <label>ESTADO CIVIL</label>
          <select class="form-control" formControlName="marital_status">
            <option value="">Seleccione...</option>
            <option value="Soltero">Soltero</option>
            <option value="Casado">Casado</option>
            <option value="Divorciado">Divorciado</option>
            <option value="Viudo">Viudo</option>
            <option value="Unión Libre">Unión Libre</option>
          </select>
        </div>
        <div class="col-md-3 mb-3">
          <label>IDENTIDAD DE GÉNERO</label>
          <input class="form-control" formControlName="gender_identity" placeholder="Identidad de género">
        </div>
        <div class="col-md-3 mb-3">
          <label>AUTOIDENTIDAD ÉTNICA</label>
          <select class="form-control" formControlName="ethnicity">
            <option value="">Seleccione...</option>
            <option value="Indígena">Indígena</option>
            <option value="Afroecuatoriano">Afroecuatoriano</option>
            <option value="Montubio">Montubio</option>
            <option value="Mestizo">Mestizo</option>
            <option value="Blanco">Blanco</option>
            <option value="Otro">Otro</option>
          </select>
        </div>
        <div class="col-md-3 mb-3" *ngIf="form.get('admission.ethnicity')?.value === 'Otro'">
          <label>ESPECIFIQUE AUTOIDENTIDAD</label>
          <input class="form-control" formControlName="ethnicity_other" placeholder="Especifique cuál">
        </div>
        <div class="col-md-3 mb-3">
          <label>RESIDENCIA</label>
          <input class="form-control" formControlName="residence" placeholder="Prov/Cantón">
        </div>
        <div class="col-md-3 mb-3">
          <label>DIRECCIÓN</label>
          <input class="form-control" formControlName="address" placeholder="Dirección domiciliaria">
        </div>
        <div class="col-md-3 mb-3">
          <label>TELÉFONO</label>
          <input class="form-control" formControlName="phone" placeholder="Teléfono celular">
        </div>
        <div class="col-md-3 mb-3">
          <label>EMAIL</label>
          <input type="email" class="form-control" formControlName="email" placeholder="correo@ejemplo.com">
        </div>
        <div class="col-md-3 mb-3">
          <label>INSTRUCCIÓN</label>
          <input class="form-control" formControlName="education" placeholder="Instrucción">
        </div>
        <div class="col-md-3 mb-3">
          <label>OCUPACIÓN / EMPRESA</label>
          <input class="form-control" formControlName="occupation" placeholder="Ocupación">
        </div>
        <div class="col-md-3 mb-3">
          <label>SANGRE Y FACTOR RH</label>
          <input class="form-control" formControlName="blood_type" placeholder="Ej. O+">
        </div>
        <div class="col-md-3 mb-3">
          <label>CONTACTO EMERGENCIA</label>
          <input class="form-control" formControlName="emergency_name" placeholder="Nombre">
        </div>
        <div class="col-md-3 mb-3">
          <label>PARENTESCO</label>
          <input class="form-control" formControlName="emergency_relationship" placeholder="Parentesco">
        </div>
        <div class="col-md-3 mb-3">
          <label>TELÉFONO EMERGENCIA</label>
          <input class="form-control" formControlName="emergency_phone" placeholder="Teléfono">
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3" formGroupName="consultation_reason">
    <div class="card-header clinical-section-header" (click)="toggleSection('consultation')">
      <h6 class="mb-0">B. MOTIVO DE CONSULTA</h6>
      <div class="clinical-header-actions">
        <span class="section-badge section-badge-required" *ngIf="isRequiredSection('consultation')">Obligatorio</span>
        <span class="section-badge section-badge-warning" *ngIf="hasMissingRequiredInSection('consultation')">Faltan datos</span>
        <i class="fa" [ngClass]="isSectionCollapsed('consultation') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </div>
    </div>
    <div class="card-body" [ngbCollapse]="isSectionCollapsed('consultation')">
      <div class="row row-sm">
        <div class="col-md-12 mb-3">
          <label class="required-field">MOTIVO PRINCIPAL</label>
          <textarea class="form-control" [ngClass]="{'is-invalid-soft': form.get('consultation_reason.main_reason')?.invalid && form.get('consultation_reason.main_reason')?.touched}" rows="3" formControlName="main_reason" placeholder="Anotar la causa principal de la atención"></textarea>
          <small class="text-danger" *ngIf="form.get('consultation_reason.main_reason')?.invalid && form.get('consultation_reason.main_reason')?.touched">Requerido</small>
        </div>
        <div class="col-md-3 mb-3">
          <label>TIEMPO DE EVOLUCIÓN</label>
          <select class="form-control" formControlName="evolution_time_unit">
            <option value="">Seleccione...</option>
            <option value="Horas">Horas</option>
            <option value="Días">Días</option>
            <option value="Semanas">Semanas</option>
            <option value="Meses">Meses</option>
          </select>
        </div>
        <div class="col-md-3 mb-3">
          <label>TIEMPO EXACTO</label>
          <input class="form-control" formControlName="exact_time" placeholder="Tiempo exacto">
        </div>
        <div class="col-md-6 mb-3">
          <label>CLASIFICACIÓN DE LA ATENCIÓN</label>
          <select class="form-control" formControlName="attention_classification">
            <option value="">Seleccione...</option>
            <option value="Primera atención (Aguda)">Primera atención (Aguda)</option>
            <option value="Control Enf. Crónica">Control Enf. Crónica</option>
            <option value="Seguimiento / Reevaluación">Seguimiento / Reevaluación</option>
            <option value="Control / Niño Sano">Control / Niño Sano</option>
            <option value="Lectura de Exámenes">Lectura de Exámenes</option>
            <option value="Renovación de Receta">Renovación de Receta</option>
            <option value="Emisión Certificado">Emisión Certificado</option>
            <option value="Trauma / Accidente">Trauma / Accidente</option>
            <option value="Interconsulta">Interconsulta</option>
          </select>
        </div>
        <div class="col-md-12" formArrayName="secondary_reasons">
          <label>MOTIVOS SECUNDARIOS</label>
          <div class="row row-sm">
            <div class="col-md-6 mb-3">
              <input class="form-control" [formControlName]="0" placeholder="1. Motivo secundario">
            </div>
            <div class="col-md-6 mb-3">
              <input class="form-control" [formControlName]="1" placeholder="2. Motivo secundario">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3" formGroupName="personal_history">
    <div class="card-header clinical-section-header" (click)="toggleSection('personalHistory')">
      <h6 class="mb-0">C. ANTECEDENTES PERSONALES Y FAMILIARES</h6>
      <i class="fa" [ngClass]="isSectionCollapsed('personalHistory') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </div>
    <div class="card-body" [ngbCollapse]="isSectionCollapsed('personalHistory')">
      <div class="row row-sm">
        <div class="col-md-6 mb-3">
          <label>ENFERMEDADES CLÍNICAS</label>
          <textarea class="form-control" rows="2" formControlName="clinical_diseases"></textarea>
        </div>
        <div class="col-md-6 mb-3">
          <label>CIRUGÍAS PREVIAS</label>
          <textarea class="form-control" rows="2" formControlName="previous_surgeries"></textarea>
        </div>
        <div class="col-md-4 mb-3">
          <label>ALERGIAS</label>
          <input class="form-control" formControlName="allergies">
        </div>
        <div class="col-md-4 mb-3">
          <label>TRANSFUSIONES</label>
          <input class="form-control" formControlName="transfusions">
        </div>
        <div class="col-md-4 mb-3">
          <label>ACTIVIDAD FÍSICA</label>
          <select class="form-control" formControlName="physical_activity">
            <option value="">Seleccione...</option>
            <option value="Sedentario">Sedentario</option>
            <option value="Activo">Activo</option>
          </select>
        </div>
        <div class="col-md-12 mb-3 clinical-checks">
          <label class="ck"><input type="checkbox" formControlName="tobacco"> Tabaco</label>
          <label class="ck"><input type="checkbox" formControlName="alcohol"> Alcohol</label>
          <label class="ck"><input type="checkbox" formControlName="drugs"> Drogas</label>
        </div>
        <div class="col-md-12 mb-3">
          <label>ANTECEDENTES FAMILIARES</label>
          <textarea class="form-control" rows="2" formControlName="family_history"></textarea>
        </div>
        <div class="col-md-12">
          <label>C.4. GINECO-OBSTÉTRICOS (SOLO MUJERES)</label>
        </div>
        <div class="col-md-2 mb-3">
          <label>MENARQUIA</label>
          <input class="form-control" formControlName="menarche" placeholder="años">
        </div>
        <div class="col-md-2 mb-3">
          <label>FUM</label>
          <input type="date" class="form-control" formControlName="fum">
        </div>
        <div class="col-md-2 mb-3">
          <label>CICLOS</label>
          <input class="form-control" formControlName="cycles" placeholder="días">
        </div>
        <div class="col-md-2 mb-3">
          <label>VIDA SEXUAL</label>
          <input class="form-control" formControlName="sexual_life" placeholder="años">
        </div>
        <div class="col-md-1 mb-3">
          <label>GESTAS</label>
          <input class="form-control" formControlName="pregnancies">
        </div>
        <div class="col-md-1 mb-3">
          <label>PARTOS</label>
          <input class="form-control" formControlName="births">
        </div>
        <div class="col-md-1 mb-3">
          <label>ABORTOS</label>
          <input class="form-control" formControlName="abortions">
        </div>
        <div class="col-md-1 mb-3">
          <label>CESÁREAS</label>
          <input class="form-control" formControlName="cesareans">
        </div>
        <div class="col-md-2 mb-3">
          <label>HIJOS VIVOS</label>
          <input class="form-control" formControlName="living_children">
        </div>
        <div class="col-md-4 mb-3">
          <label>PAP</label>
          <input class="form-control" formControlName="pap">
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3" formGroupName="current_illness">
    <div class="card-header clinical-section-header" (click)="toggleSection('currentIllness')">
      <h6 class="mb-0">D. ENFERMEDAD ACTUAL</h6>
      <div class="clinical-header-actions">
        <span class="section-badge section-badge-required" *ngIf="isRequiredSection('currentIllness')">Obligatorio</span>
        <span class="section-badge section-badge-warning" *ngIf="hasMissingRequiredInSection('currentIllness')">Faltan datos</span>
        <i class="fa" [ngClass]="isSectionCollapsed('currentIllness') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </div>
    </div>
    <div class="card-body" [ngbCollapse]="isSectionCollapsed('currentIllness')">
      <div class="row row-sm">
        <div class="col-md-12 mb-3">
          <label class="required-field">INICIO Y EVOLUCIÓN</label>
          <textarea class="form-control" [ngClass]="{'is-invalid-soft': form.get('current_illness.start_evolution')?.invalid && form.get('current_illness.start_evolution')?.touched}" rows="3" formControlName="start_evolution"></textarea>
          <small class="text-danger" *ngIf="form.get('current_illness.start_evolution')?.invalid && form.get('current_illness.start_evolution')?.touched">Requerido</small>
        </div>
        <div class="col-md-12 mb-3">
          <label>ESTADO ACTUAL Y CARACTERÍSTICAS</label>
          <textarea class="form-control" rows="3" formControlName="current_state"></textarea>
        </div>
        <div class="col-md-3 mb-3">
          <label>INTENSIDAD DEL DOLOR EVA 1-10</label>
          <input type="number" min="1" max="10" class="form-control" formControlName="pain_intensity">
        </div>
        <div class="col-md-9 mb-3">
          <label>SÍNTOMAS ASOCIADOS / TRAT. PREVIOS</label>
          <input class="form-control" formControlName="associated_symptoms">
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3" formGroupName="systems_review">
    <div class="card-header clinical-section-header" (click)="toggleSection('systemsReview')">
      <h6 class="mb-0">E. REVISIÓN DE ÓRGANOS Y SISTEMAS</h6>
      <i class="fa" [ngClass]="isSectionCollapsed('systemsReview') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </div>
    <div class="card-body" formArrayName="items" [ngbCollapse]="isSectionCollapsed('systemsReview')">
      <div class="clinical-grid-row clinical-grid-head">
        <div>SISTEMA</div>
        <div>SP</div>
        <div>CP</div>
        <div>DESCRIPCIÓN DE HALLAZGOS PATOLÓGICOS</div>
      </div>
      <div class="clinical-grid-row" *ngFor="let item of systemsReview.controls; let i = index" [formGroupName]="i">
        <div>{{ item.get('system')?.value }}</div>
        <div><input type="radio" value="SP" formControlName="status"></div>
        <div><input type="radio" value="CP" formControlName="status"></div>
        <div><input class="form-control form-control-sm" formControlName="description"></div>
      </div>
    </div>
  </div>

  <div class="card mb-3" formGroupName="vital_signs">
    <div class="card-header clinical-section-header" (click)="toggleSection('vitalSigns')">
      <h6 class="mb-0">F. SIGNOS VITALES Y ANTROPOMETRÍA</h6>
      <i class="fa" [ngClass]="isSectionCollapsed('vitalSigns') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </div>
    <div class="card-body" [ngbCollapse]="isSectionCollapsed('vitalSigns')">
      <div class="row row-sm">
        <div class="col-md-12 mb-3">
          <label>OBSERVACIÓN GENERAL / CONTEXTO CLÍNICO</label>
          <textarea class="form-control" rows="2" formControlName="notes" placeholder="Observación previa a signos vitales y antropometría"></textarea>
        </div>
        <div class="col-md-2 mb-3"><label>PRESIÓN ARTERIAL</label><input class="form-control" formControlName="blood_pressure"></div>
        <div class="col-md-2 mb-3"><label>FREC. CARDÍACA</label><input class="form-control" formControlName="heart_rate"></div>
        <div class="col-md-2 mb-3"><label>FREC. RESPIRATORIA</label><input class="form-control" formControlName="respiratory_rate"></div>
        <div class="col-md-2 mb-3"><label>TEMPERATURA</label><input class="form-control" formControlName="temperature"></div>
        <div class="col-md-2 mb-3"><label>SATURACIÓN O2</label><input class="form-control" formControlName="oxygen_saturation"></div>
        <div class="col-md-2 mb-3"><label>PESO</label><input class="form-control" formControlName="weight"></div>
        <div class="col-md-2 mb-3"><label>TALLA</label><input class="form-control" formControlName="height"></div>
        <div class="col-md-2 mb-3"><label>IMC</label><input class="form-control" formControlName="bmi"></div>
        <div class="col-md-2 mb-3"><label>PERÍM. CEFÁLICO</label><input class="form-control" formControlName="head_circumference"></div>
        <div class="col-md-2 mb-3"><label>GLICEMIA</label><input class="form-control" formControlName="glucose"></div>
      </div>
    </div>
  </div>

  <div class="card mb-3" formGroupName="physical_exam">
    <div class="card-header clinical-section-header" (click)="toggleSection('physicalExam')">
      <h6 class="mb-0">G. EXAMEN FÍSICO REGIONAL</h6>
      <i class="fa" [ngClass]="isSectionCollapsed('physicalExam') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </div>
    <div class="card-body" [ngbCollapse]="isSectionCollapsed('physicalExam')">
      <div formArrayName="items">
        <div class="clinical-grid-row clinical-grid-head exam">
          <div>REGIÓN</div>
          <div>NORMAL</div>
          <div>ANORMAL</div>
          <div>DESCRIPCIÓN DE HALLAZGOS</div>
        </div>
        <div class="clinical-grid-row exam" *ngFor="let item of physicalExam.controls; let i = index" [formGroupName]="i">
          <div>{{ item.get('region')?.value }}</div>
          <div><input type="radio" value="normal" formControlName="status"></div>
          <div><input type="radio" value="abnormal" formControlName="status"></div>
          <div><input class="form-control form-control-sm" formControlName="description"></div>
        </div>
      </div>
      <div class="row row-sm mt-3">
        <div class="col-md-2">
          <label>GLASGOW /15</label>
          <input class="form-control" formControlName="glasgow">
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3">
    <div class="card-header clinical-card-actions clinical-section-header" (click)="toggleSection('diagnoses')">
      <h6 class="mb-0">H. DIAGNÓSTICO</h6>
      <div class="clinical-header-actions">
        <button type="button" class="btn btn-sm btn-primary" (click)="$event.stopPropagation(); addDiagnosis()">Agregar diagnóstico</button>
        <i class="fa" [ngClass]="isSectionCollapsed('diagnoses') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </div>
    </div>
    <div class="card-body" formArrayName="diagnoses" [ngbCollapse]="isSectionCollapsed('diagnoses')">
      <div class="diagnosis-row diagnosis-head">
        <div>N°</div>
        <div>DESCRIPCIÓN DEL DIAGNÓSTICO</div>
        <div>CIE-10</div>
        <div>TIPO</div>
        <div></div>
      </div>
      <div class="diagnosis-row" *ngFor="let item of diagnoses.controls; let i = index" [formGroupName]="i">
        <div>{{ i + 1 }}</div>
        <div><input class="form-control form-control-sm" formControlName="description"></div>
        <div><input class="form-control form-control-sm" formControlName="cie10"></div>
        <div>
          <select class="form-control form-control-sm" formControlName="type">
            <option value="PRE">PRE</option>
            <option value="DEF">DEF</option>
          </select>
        </div>
        <div>
          <button type="button" class="btn btn-sm btn-danger" (click)="removeDiagnosis(i)">Quitar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3" formGroupName="treatment_plan">
    <div class="card-header clinical-section-header" (click)="toggleSection('treatmentPlan')">
      <h6 class="mb-0">I. PLAN DE MANEJO Y TRATAMIENTO</h6>
      <i class="fa" [ngClass]="isSectionCollapsed('treatmentPlan') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
    </div>
    <div class="card-body" [ngbCollapse]="isSectionCollapsed('treatmentPlan')">
      <div class="row row-sm">
        <div class="col-md-12 mb-3">
          <label>PLAN DIAGNÓSTICO (EXÁMENES E IMAGEN)</label>
          <textarea class="form-control" rows="3" formControlName="diagnostic_plan"></textarea>
        </div>
        <div class="col-md-12 mb-3">
          <label>PLAN TERAPÉUTICO (PRESCRIPCIÓN FARMACOLÓGICA)</label>
          <textarea class="form-control" rows="4" formControlName="pharmacological_prescription"></textarea>
        </div>
        <div class="col-md-4 mb-3"><label>DIETA / CUIDADOS</label><input class="form-control" formControlName="diet_care"></div>
        <div class="col-md-2 mb-3 clinical-checks clinical-checks-inline"><label class="ck"><input type="checkbox" formControlName="medical_rest"> Reposo médico</label></div>
        <div class="col-md-2 mb-3"><label>DÍAS</label><input type="number" class="form-control" formControlName="rest_days"></div>
        <div class="col-md-2 mb-3"><label>DESDE</label><input type="date" class="form-control" formControlName="rest_from"></div>
        <div class="col-md-2 mb-3"><label>HASTA</label><input type="date" class="form-control" formControlName="rest_to"></div>
        <div class="col-md-8 mb-3"><label>SIGNOS DE ALARMA</label><input class="form-control" formControlName="alarm_signs"></div>
        <div class="col-md-4 mb-3"><label>PRÓXIMA CITA</label><input type="date" class="form-control" formControlName="next_appointment"></div>
      </div>
    </div>
  </div>

  <div class="card mb-3" formGroupName="professional_data">
    <div class="card-header clinical-section-header" (click)="toggleSection('professionalData')">
      <h6 class="mb-0">J. DATOS DEL PROFESIONAL</h6>
      <div class="clinical-header-actions">
        <span class="section-badge section-badge-required" *ngIf="isRequiredSection('professionalData')">Obligatorio</span>
        <span class="section-badge section-badge-warning" *ngIf="hasMissingRequiredInSection('professionalData')">Faltan datos</span>
        <i class="fa" [ngClass]="isSectionCollapsed('professionalData') ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </div>
    </div>
    <div class="card-body" [ngbCollapse]="isSectionCollapsed('professionalData')">
      <div class="row row-sm">
        <div class="col-md-2 mb-3"><label class="required-field">FECHA</label><input type="date" class="form-control" [ngClass]="{'is-invalid-soft': form.get('professional_data.date')?.invalid && form.get('professional_data.date')?.touched}" formControlName="date"></div>
        <div class="col-md-2 mb-3"><label class="required-field">HORA INICIO</label><input type="time" class="form-control" [ngClass]="{'is-invalid-soft': form.get('professional_data.start_time')?.invalid && form.get('professional_data.start_time')?.touched}" formControlName="start_time"></div>
        <div class="col-md-2 mb-3"><label>HORA FIN</label><input type="time" class="form-control" formControlName="end_time"></div>
        <div class="col-md-4 mb-3"><label class="required-field">NOMBRE DEL MÉDICO TRATANTE</label><input class="form-control" [ngClass]="{'is-invalid-soft': form.get('professional_data.doctor_name')?.invalid && form.get('professional_data.doctor_name')?.touched}" formControlName="doctor_name"></div>
        <div class="col-md-2 mb-3"><label>CÓDIGO MSP / SENESCYT</label><input class="form-control" formControlName="msp_code"></div>
      </div>
    </div>
  </div>

  <div class="clinical-footer-actions">
    <button type="button" class="btn ripple btn-secondary" (click)="cancel()">Cerrar</button>
    <button type="button" class="btn ripple btn-outline-primary" [disabled]="!order" (click)="previsualizarPdf()">
      <i class="fa fa-file-pdf-o me-1"></i>
      Previsualizar PDF
    </button>
    <button type="button" class="btn ripple btn-primary" [disabled]="saving" (click)="save()">
      {{ saving ? 'Guardando...' : (isEditMode ? 'Actualizar' : 'Guardar') }}
    </button>
    <button type="button" class="btn ripple btn-info" [disabled]="!order" (click)="solicitarServiciosOrden()">
      <i class="fa fa-plus-square me-1"></i>
      Solicitar servicios
    </button>
  </div>
</form>
